'use client';
import React from 'react';
import { useCartService } from '@/hooks/cart/useCartService';
import { CartWithItemView } from './views/CartWithItemView';
import { CartEmptyView } from './views/CartEmptyView';
import { Flex, Spinner } from '@chakra-ui/react';
import { Condition } from '@/utils/react';
import { useMutationLoading } from '@/hooks/utils/useMutationLoading';
import { CART_QUERY_KEYS } from '@/infrastructure/cart/utils/keys';

const CART_LOADING_INDICATOR_TEST_ID = 'cart-loading-indicator';

const ShoppingBagDrawerContent = () => {
  const { useGetCart } = useCartService();
  const { data } = useGetCart();

  const isLoading = useMutationLoading(CART_QUERY_KEYS.default());

  return (
    <>
      <Condition
        expression={isLoading}
        then={
          <Flex
            position="absolute"
            height="100vh"
            width="100%"
            top={0}
            left={0}
            backdropFilter="blur(1px)"
            backgroundColor="rgba(0, 0, 0, 0.2)"
            zIndex="banner"
            alignItems="center"
            justifyContent="center"
            data-testid={CART_LOADING_INDICATOR_TEST_ID}
          >
            <Spinner color="brand.60" size="xl" animationDuration="0.8s" />
          </Flex>
        }
      />

      {data?.cart?.item?.length ? <CartWithItemView /> : <CartEmptyView />}
    </>
  );
};

export default ShoppingBagDrawerContent;
